import type { AppSuiteApp } from '../../types/appSuites'

/** Landing path the user can actually open, or null when the app is locked. */
export function resolveLanding(
  app: AppSuiteApp,
  isItemVisible: (itemId: string) => boolean,
  pathById: Record<string, string>,
): string | null {
  const landingItem = app.sections
    .flatMap((section) => section.item_ids)
    .find((itemId) => pathById[itemId] === app.landing_path)
  if (landingItem && isItemVisible(landingItem)) return app.landing_path
  for (const section of app.sections) {
    for (const itemId of section.item_ids) {
      if (isItemVisible(itemId) && pathById[itemId]) return pathById[itemId]
    }
  }
  return null
}
